(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["desky-cart-main-slider"] && !Shopify.designMode) return;
  try {
    
    if (!window.location.href.includes('/products/')) {
      class ProductRecommendations extends HTMLElement {
        constructor() {
          super();

          const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
              .then((response) => response.text())
              .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('product-recommendations');
                if (recommendations && recommendations.innerHTML.trim().length) {
                  this.innerHTML = recommendations.innerHTML;
                }
              })
              .catch((e) => {
                console.error(e);
              });
          };
          new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
        }
      }

      customElements.define('product-recommendations', ProductRecommendations);
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Get popups by their specific IDs
    const returnsPopup = document.querySelector('#returns-popup');
    const warrantyPopup = document.querySelector('#warranty-popup');

    // Returns popup functionality
    const returnsButton = document.getElementById('footer-open-returns');
    if (returnsButton && returnsPopup) {
      returnsButton.addEventListener('click', function () {
        returnsPopup.classList.remove('dy:hidden');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
      });
    }

    // Warranty popup functionality (#footer-open-warranty + .js-open-warranty on page CTAs)
    const warrantyButtons = document.querySelectorAll('#footer-open-warranty, .js-open-warranty');
    if (warrantyButtons.length && warrantyPopup) {
      warrantyButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          warrantyPopup.classList.remove('dy:hidden');
          document.body.style.overflow = 'hidden'; // Prevent background scrolling
        });
      });
    }

    // Shipping popup functionality
    const shippingButton = document.getElementById('footer-open-shipping');
    const shippingPopupEl = document.getElementById('shipping-popup');
    if (shippingButton && shippingPopupEl) {
      shippingButton.addEventListener('click', function (e) {
        e.preventDefault();
        shippingPopupEl.classList.remove('dy:hidden');
        if (typeof window.shipShowStep === 'function') {
          window.shipShowStep(1);
        }
        document.body.style.overflow = 'hidden';
      });
    }

    // General enquiry popup functionality
    const generalEnquiryButton = document.getElementById('show-form-wrapper');
    const generalQueryPopupEl = document.getElementById('general-query-popup');
    if (generalEnquiryButton && generalQueryPopupEl) {
      generalEnquiryButton.addEventListener('click', function (e) {
        e.preventDefault();
        generalQueryPopupEl.classList.remove('dy:hidden');
        if (typeof window.gqShowStep === 'function') {
          window.gqShowStep(1);
        }
        document.body.style.overflow = 'hidden';
      });
    }

    // Close popup functionality (for both popups)
    const closeButtons = document.querySelectorAll('#closePopup');
    closeButtons.forEach(function (closeButton) {
      closeButton.addEventListener('click', function () {
        const popup = closeButton.closest('#returns-popup, #warranty-popup');
        if (popup) {
          popup.classList.add('dy:hidden');
          document.body.style.overflow = 'auto'; // Restore scrolling
        }
      });
    });

    // Close popup when clicking outside
    [returnsPopup, warrantyPopup].forEach(function (popup) {
      if (popup) {
        popup.addEventListener('click', function (e) {
          if (e.target === popup) {
            popup.classList.add('dy:hidden');
            document.body.style.overflow = 'auto'; // Restore scrolling
          }
        });
      }
    });

    // Close popup with Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const visiblePopup = document.querySelector(
          '#returns-popup:not(.dy\\:hidden), #warranty-popup:not(.dy\\:hidden)'
        );
        if (visiblePopup) {
          visiblePopup.classList.add('dy:hidden');
          document.body.style.overflow = 'auto'; // Restore scrolling
        }
      }
    });

    // Check URL parameters and open popups if needed
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('returns-popup') === 'true') {
      const returnsPopup = document.getElementById('returns-popup');
      if (returnsPopup) {
        returnsPopup.classList.remove('dy:hidden');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
      }
    }
    if (urlParams.get('warranty-popup') === 'true') {
      const warrantyPopup = document.getElementById('warranty-popup');
      if (warrantyPopup) {
        warrantyPopup.classList.remove('dy:hidden');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
      }
    }
    if (urlParams.get('general-query-popup') === 'true') {
      const generalQueryPopup = document.getElementById('general-query-popup');
      if (generalQueryPopup) {
        generalQueryPopup.classList.remove('dy:hidden');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
      }
    }
    if (urlParams.get('shipping-popup') === 'true') {
      const shippingPopup = document.getElementById('shipping-popup');
      if (shippingPopup) {
        shippingPopup.classList.remove('dy:hidden');
        document.body.style.overflow = 'hidden'; // Prevent background scrolling
      }
    }
  });

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    
    //ModalDialog
    class ProductModal extends HTMLElement {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }

    customElements.define('product-modal', ProductModal);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
                            //ModalDialog 
  class ProductModal extends HTMLElement  {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
